<template>
  <WsRead
    localeMode
    titleKey="name"
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customBtns="_customBtns"
    :calloutIcon="callout.icon"
    :calloutTitle="callout.title"
    :isCalloutShow="!_isReleased"
    :calloutBackgroundColor="callout.backgroundColor"
    @input="$_getModelData($event)"
    @release="$_onOpenReleaseAlertDialog"
  >
    <WsAlertDialog
      ref="releaseAlertDialog"
      title="發布"
      btnText="確認"
      description="確定要發布嗎？"
      @submit="$_onRelease"
    />
  </WsRead>
</template>

<script>
import model from '@/models/announcement';
import S_announcement from '@/services/api/v1/announcement';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'locales',
                  'author',
                  'authorizer',
                  'cover_image',
                  'attaches',
                ],
              },
            ],
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'alliance',
                  'reads',
                ],
              },
            ],
          },
          {
            type: "activeSwitch",
            title: "顯示設定",
            remark: "隱藏的內容將不會顯示於前端",
            field: "is_active",
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '發布資訊',
                fields: ['released_at', 'released_admin'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '建立資訊',
                fields: ['created_at', 'created_admin'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '編輯資訊',
                fields: ['updated_at', 'updated_admin'],
              },
            ],
          },
        ],
      },
      modelData: {},
      callout: {
        icon: {
          type: 'mdi-information-outline',
          color: '#116795',
        },
        title: {
          text: '此新訊尚未發布，請盡快發布',
          color: '#116795',
        },
        backgroundColor: '#ddeef7',
      },
    };
  },
  computed: {
    _isReleased() {
      return this.modelData.is_released === 1;
    },
    _customBtns() {
      if (this._isReleased) return;
      return [
        {
          title: '發布',
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-update',
          emit: 'release',
        },
      ];
    }
  },
  methods: {
    $_getModelData(modelData) {
      this.modelData = modelData;
    },
    $_onOpenReleaseAlertDialog() {
      this.$refs.releaseAlertDialog.open();
    },
    async $_onRelease() {
      const alertDialog = this.$refs.releaseAlertDialog;
      alertDialog.startLoading();
      try {
        await S_announcement.release(this.modelData.id);
        alertDialog.close();
        this.modelData.is_released = 1;
      } catch (error) {
        alert(error);
      } finally {
        alertDialog.stopLoading();
      }
    },
  },
};
</script>